"use client";

import { DialogSignin } from "@/components/DialogSignin";
import { useIsLoggedIn } from "@/features/auth/services";
import profileService from "@/features/profile/service";
import { TUser } from "@/features/profile/types";
import { useEffect, useState } from "react";
import Image from "next/image";

export function Hero() {
  const [user, setUser] = useState<TUser | null>(null);
  const [openDialogSignin, setOpenDialogSignin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const isLoggedIn = useIsLoggedIn();

  useEffect(() => {
    const getUser = async () => {
      try {
        setIsLoading(true);
        const user = await profileService.getUser();
        setUser(user);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };

    getUser();
  }, []);

  return (
    <>
      <DialogSignin isOpen={openDialogSignin} onClose={setOpenDialogSignin} />
      <section
        id="hero"
        className="relative bg-white pb-12 md:pt-24 md:pb-24 shadow-sm px-4"
      >
        <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-12 md:gap-16">
          <div className="flex-1 flex justify-center md:justify-end">
            <Image
              src="/image/hero.jpg"
              alt="รางวัลความสำเร็จของนายหน้าประกันศรีกรุง - โทรฟีและเกียรติยศที่ได้รับ"
              width={600}
              height={400}
              className="w-full max-w-[500px] md:max-w-[600px] h-auto object-cover rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
              priority
              fetchPriority="high"
            />
          </div>
          <div className="flex-1 max-w-xl">
            <h1 className="text-2xl font-bold leading-tight mb-3 text-[#126d37]">
              รับสมัครนายหน้าประกันภัย มีสาขา ให้บริการกว่า 49 สาขา
            </h1>
            <p className="text-xl font-bold leading-tight mb-3 text-[#188F46]">
              ยินดีต้อนรับสู่ www.agentsrikrung.com
              เปลี่ยนชีวิตคุณเป็นเจ้าของธุรกิจง่ายๆ พร้อมรายได้ที่ไม่จำกัด
            </p>
            <p className="text-xl mb-3 leading-relaxed text-gray-700">
              คุณเคยคิดไหมว่า... คุณสามารถเป็นเจ้าของธุรกิจของตัวเองได้
              โดยไม่ต้องลงทุนสูง หรือเสี่ยงมาก? ที่ ศรีกรุงโบรคเกอร์
              เรามอบโอกาสให้คุณเปลี่ยนความฝันให้เป็นจริง ด้วยอาชีพ
            </p>
            <p className="text-xl mb-8 font-bold leading-tight text-[#126d37]">
              นายหน้าประกันภัย เริ่มต้นง่าย ไม่จำเป็นต้องมีประสบการณ์!
            </p>
            {isLoading ? (
              <></>
            ) : (
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center md:justify-start">
                <a
                  href="/member-register"
                  data-name="register-member"
                  className="h-[50px] md:w-[160px] px-8 py-3 bg-[#126d37] text-white rounded-full font-bold hover:bg-[#005825] transition text-lg shadow-md hover:shadow-lg text-center focus:outline-none focus:ring-4 focus:ring-[#126d37]/50"
                  aria-label="สมัครเป็นสมาชิกนายหน้าประกันศรีกรุง"
                >
                  สมัครสมาชิก
                </a>
                {user == null && !isLoggedIn && (
                  <button
                    type="button"
                    name="signin-button"
                    onClick={() => setOpenDialogSignin(true)}
                    className="h-[50px] md:w-[160px] px-8 py-3 border-2 border-[#126d37] bg-[#126d37] text-white rounded-full font-bold hover:bg-[#005825] transition text-lg shadow-md hover:shadow-lg text-center focus:outline-none focus:ring-4 focus:ring-[#126d37]/50"
                    aria-label="เข้าสู่ระบบสำหรับสมาชิก"
                  >
                    เข้าสู่ระบบ
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default Hero;
